import { FC } from 'react';
import { useHref, useLinkClickHandler } from 'react-router-dom';

import { Link } from '@argenta/react-ui';

import { useLanguage } from '../../hooks/useLanguage';
import { mapVacancyTo } from '../../utils/navigation';

import { I18nLinkProps } from './I18nLink.types';

export const I18nLink: FC<I18nLinkProps> = ({
  onClick,
  replace = false,
  state,
  target,
  to,
  ...rest
}) => {
  const { language } = useLanguage();
  const mappedTo = mapVacancyTo(to, language);

  const href = useHref(mappedTo);
  const handleClick = useLinkClickHandler(mappedTo, {
    replace,
    state,
    target,
  });

  return (
    <Link
      {...rest}
      href={href}
      onClick={(event) => {
        onClick?.(event);
        if (!event.defaultPrevented) {
          handleClick(event);
        }
      }}
      target={target}
    />
  );
};
